import { getCookie } from './storage';


export const setGrayId = header => {
  let id;
  if ((id = window.sessionStorage.getItem('userId'))) {
    header['gray-id'] = id;
  } else if ((id = window.sessionStorage.getItem('initGrayId'))) {
    header['gray-id'] = id;
  } else if ((id = getCookie('gray-id'))) {
    header['gray-id'] = id;
  }
  return header;
};
